import css from 'styled-jsx/css';
import { colors, typography, zIndex } from '../../../config/styles';

export const ProductSpecificationConnectStyles = css`
  /* Block: Main component */
  .product-specification-connect {
    display: flex;
    flex-direction: column;
    margin-top: 9px;
  }

  /* Elements: Component parts */
  .product-specification-connect__specifications {
    width: 100%;
    height: auto;
  }

  .product-specification-connect__content {
    width: 100%;
    height: auto;
  }

  .product-specification-connect__plan-active {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }

  .product-specification-connect__prices {
    padding: 0;
  }

  .product-specification-connect__prices-content {
    margin-top: 20px;
  }

  .product-specification-connect__info-message {
    font-size: ${typography.lg1};
    margin-bottom: 10px;
    font-weight: 550;
    color: ${colors.gray.shade15};
  }

  .product-specification-connect__plan-review {
    padding-bottom: 15px;
  }

  .product-specification-connect__plan-text {
    font-size: ${typography.base};
    line-height: 17px;
    font-weight: 400;
    color: ${colors.black.shade1};
    margin: 0;
  }

  .product-specification-connect__button-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    max-width: 70%;
  }

  .product-specification-connect__button-container :global(a) {
    height: 40px !important;
  }

  .product-specification-connect__button-container :global(.container-my-lists) {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e0e0e0;
    border-radius: 25px;
    background-color: ${colors.white.shade4};
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }

  .product-specification-connect__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .product-specification-connect__button-text {
    display: flex;
    align-items: center;
  }

  .product-specification-connect__no-plan {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .product-specification-connect__no-plan-header {
    margin: 0;
  }

  .product-specification-connect__no-plan-text {
    font-size: ${typography.base};
    line-height: 17px;
    margin: 0;
  }

  .product-specification-connect__button-container--mobile {
    box-shadow: 0 -3px 26px rgba(0, 0, 0, 0.1);
    background-color: ${colors.white.shade1};
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 21px;
    z-index: ${zIndex.pdp.addToCartButton};
    justify-content: center;
  }

  .product-specification-connect__button-container--mobile .product-specification-connect__button {
    width: 100%;
  }

  /* Responsive design */
  @mixin tabletToDesktop {
    .product-specification-connect {
      flex-direction: row;
    }

    .product-specification-connect__specifications {
      width: 50%;
      min-height: 500px;
    }

    .product-specification-connect__info-message {
      font-size: ${typography.base};
    }

    .product-specification-connect__no-plan-text {
      font-size: ${typography.sm1};
    }
  }

  /* Global icon styles */
  :global(.csicon-arrow_right) {
    font-size: ${typography.sm};
  }

  :global(.csicon-arrow_down_small) {
    margin-left: 9px;
    font-size: ${typography.xs2};
  }

  .variant-id-seller {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-top: 32px;
  }

  .variant-id-seller :global(.variant-id) {
    font-size: 12px;
  }
`;
